// Time values in milliseconds
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export const CACHE_CONSTANTS = {
    // Refresh static data twice a week (every 3.5 days)
    STATIC_DATA_STALE_TIME: 3.5 * MILLISECONDS_PER_DAY,
    MEDIUM_DATA_STALE_TIME: 5 * 60 * 1000,
} as const;
